import { Stack as MantineStack, StackProps } from '@mantine/core';

export type IStackProps = StackProps;

/** @registry Design-layer pass-through over Mantine Stack; import this instead of @mantine/core Stack outside src/design. */
export const Stack = MantineStack;
